import {
  AssetLogo,
  isSvgIconName,
  LogoTypes,
  SvgIconNames,
} from '@toggle/design-system';
import { StrictUnion } from '@toggle/helpers';
import { Entity, getAssetLogoFromEntity, MappedEntity } from '@toggle/toggle';
import React from 'react';

import { useThemeStore } from '../theme-controller/stores/useThemeStore';
import { isDarkTheme } from '../theme-controller/utils/theme-utils/theme-utils';

export type AssetLogoContainerProps = {
  isDarkTheme?: boolean;
  entity: StrictUnion<Entity | MappedEntity>;
  size?: number;
  withFallback?: boolean;
};

export const AssetLogoContainer = (props: AssetLogoContainerProps) => {
  const themeName = useThemeStore(state => state.themeName);
  const isDark = isDarkTheme(themeName);
  const {
    entity: mappedEntity,
    variant,
    isNotStockEntity,
    isFiEntity,
    iconName,
    subClassIcon,
  } = getAssetLogoFromEntity(props.entity);

  const safeIconName: SvgIconNames = isSvgIconName(iconName)
    ? iconName
    : 'ChartLine';
  const safeSubClassIcon: SvgIconNames = isSvgIconName(subClassIcon)
    ? subClassIcon
    : 'ChartLine';

  const type = variant ? LogoTypes[variant] : undefined;
  const logoUrl = isDark
    ? mappedEntity.logo_urls.light_png
    : mappedEntity.logo_urls.dark_png;

  return (
    <AssetLogo
      {...props}
      type={type}
      isNotStockEntity={isNotStockEntity}
      isFiEntity={isFiEntity}
      placeholderIconName={safeIconName}
      placeholderSubClassIcon={safeSubClassIcon}
      entity={mappedEntity}
      logoUrl={logoUrl}
    />
  );
};
